module.exports = __webpack_public_path__ + "components/outside-promo-page/static/wave-c7ea5a910efa840bdd774c55a6cee649.webp";